// import { Button } from '@warp-ds/react';

const ContactButton = () => (
    <>
        <finn-contact-button data-testid="finn-contact-button"></finn-contact-button>

        {/* Contact button for local testing */}
        {/* <Button href="/messages/new/238199052" primary className="flex max-w-full!">
            Send melding
        </Button> */}
    </>
);

export default ContactButton;
